var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Factsheet__Footer mt-2 d-flex justify-content-between"},[_c('img',{staticClass:"Footer__Logo",attrs:{"src":_vm.logoSrc}}),_c('div',{staticClass:"Footer__Text font-italic"},[_vm._t("default")],2),(_vm.generatedAt)?_c('div',{staticClass:"Footer__Timestamp",domProps:{"textContent":_vm._s(_vm.generatedAt)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }